import {Suspense} from 'react';
import {BaseUser} from '@legit.health/ui';
import {Box, Button, Grid, Skeleton, Typography} from '@mui/material';
import {TFunction} from 'i18next';
import {Modal} from '@/shared/components/ui/Modal';
import useModal from '@/shared/hooks/useModal';
import SelectTemporaryImagesForm from './SelectTemporaryImagesForm';

export default function SelectTemporaryImages({
  maxImages,
  onFinish,
  patient,
  t
}: {
  maxImages: number;
  onFinish: (images: Blob[]) => void;
  patient: BaseUser;
  t: TFunction;
}) {
  const modal = useModal();

  function handleFinish(images: Blob[]) {
    modal.close();
    onFinish(images);
  }

  return (
    <Box>
      <Typography
        sx={{
          mb: '16px'
        }}
      >
        {t('ui:temporaryImages.description')}
      </Typography>
      <Button variant="outlined" color="secondary" onClick={modal.open}>
        {t('ui:temporaryImages.selectImages')}
      </Button>
      <Modal
        title={t('ui:temporaryImages.selectImages')}
        isOpened={modal.isOpened}
        onClose={modal.close}
        size="lg"
        id="selectImages"
      >
        <Suspense
          fallback={
            <Box>
              <Grid container spacing={4}>
                <Grid
                  size={{
                    xs: 12,
                    lg: 3
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    sx={{
                      width: {
                        xs: '100%',
                        lg: '200px'
                      },
                      height: {
                        xs: '200px',
                        lg: '200px'
                      }
                    }}
                  />
                </Grid>
                <Grid size={3}>
                  <Skeleton
                    variant="rounded"
                    sx={{
                      width: {
                        xs: '100%',
                        lg: '200px'
                      },
                      height: {
                        xs: '200px',
                        lg: '200px'
                      }
                    }}
                  />
                </Grid>
                <Grid size={3}>
                  <Skeleton
                    variant="rounded"
                    sx={{
                      width: {
                        xs: '100%',
                        lg: '200px'
                      },
                      height: {
                        xs: '200px',
                        lg: '200px'
                      }
                    }}
                  />
                </Grid>
                <Grid size={3}>
                  <Skeleton
                    variant="rounded"
                    sx={{
                      width: {
                        xs: '100%',
                        lg: '200px'
                      },
                      height: {
                        xs: '200px',
                        lg: '200px'
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          }
        >
          <SelectTemporaryImagesForm
            patient={patient}
            t={t}
            onFinish={handleFinish}
            maxImages={maxImages}
          />
        </Suspense>
      </Modal>
    </Box>
  );
}
